import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../../constants/styles';
const {
  ADMIN_TEXT_COLOR,
  STATUS_PARENT_BG_COLOR,
  STATUS_PARENT_HOVER_BG_COLOR,
  STATUS_RED_COLOR,
  STATUS_GREEN_COLOR,
  STATUS_YELLOW_COLOR
} = constants;

let styles = {
  cards: {
    backgroundColor: STATUS_PARENT_BG_COLOR,
    display: 'flex',
    flexFlow: 'column',
    height: 150,
    flex: 0.3,
    minWidth: 200,
    borderRadius: 8,
    paddingTop: 0,
    overflow: 'hidden',
    textDecoration: 'none',
    color: ADMIN_TEXT_COLOR,
    position: 'relative',
    margin: 10,
    padding: 10,
    ':hover': {
      backgroundColor: STATUS_PARENT_HOVER_BG_COLOR
    }
  },
  cardsAp: {
    marginLeft: 30,
    marginRight: 30
  },
  cardGateway: {
    marginLeft: 0
  },
  cardsRp: {
    marginLeft: 30,
    marginRight: 0
  },
  fieldHeader: {
    flex: 1,
    display: 'flex',
    flexFlow:'row'
  },
  field: {
    display: 'flex',
    width: '100%'
  },
  title: {
    paddingLeft: 10,
    flex: 0.5,
    fontSize: 19,
    fontWeight: 300,
    fontFamily: 'Montserrat'
  },
  stylesRed: {
    backgroundColor: STATUS_RED_COLOR,
    height: '9px',
    width: '9px',
    borderRadius: '50%',
    display: 'inline-flex',
    marginRight: 5,
    position: 'relative',
    left: -13,
    top: -4
  },
  stylesGreen: {
    backgroundColor: STATUS_GREEN_COLOR,
    height: '9px',
    width: '9px',
    borderRadius: '50%',
    display: 'inline-flex',
    marginRight: 5,
    position: 'relative',
    left: -13,
    top: -4
  },
  stylesYellow: {
    backgroundColor: STATUS_YELLOW_COLOR,
    height: '9px',
    width: '9px',
    borderRadius: '50%',
    display: 'inline-flex',
    marginRight: 5,
    position: 'relative',
    left: -13,
    top: -4
  },
  stylesRedParent: {
    backgroundColor: STATUS_RED_COLOR,
    height: '17px',
    width: '17px',
    borderRadius: '50%',
    display: 'inline-flex',
    opacity: 0.5
  },
  stylesGreenParent: {
    backgroundColor: STATUS_GREEN_COLOR,
    height: '17px',
    width: '17px',
    borderRadius: '50%',
    display: 'inline-flex',
    opacity: 0.5
  },
  stylesYellowParent: {
    backgroundColor: STATUS_YELLOW_COLOR,
    height: '17px',
    width: '17px',
    borderRadius: '50%',
    display: 'inline-flex',
    opacity: 0.5
  },
  stylesWrapper: {
    flex: 0.25,
    display: 'flex',
    flexFlow: 'row',
    alignSelf: 'flex-bottom',
    justifyItems: 'center',
    width: '100%'
  },
  stylesCommon: {
    flex: 1,
    textAlign: 'center',
    fontSize: 21,
    fontFamily: 'Montserrat'
  },
  totalCount: {
    paddingRight: 26,
    flex: 0.5,
    textAlign: 'right',
    fontFamily: 'Montserrat',
    fontSize: 34
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/data/status/common/statusSummary.styles.js